import React from 'react'
import { I18n } from '@front/volcanion/'
import { OptionUtils } from '@front/volcanion/utils'

import { Typography, Grid, Box, StepLabel, StepContent } from '@mui/material'
import { TextField, ModelMenuSelectorField } from '@front/squirtle/'

const Title = ({ title }) =>
  <Grid container>
    <Grid size="grow">
      <Typography sx={{ fontSize: 'subtitle2.fontSize', color: 'primary.main' }}>{title}</Typography>
    </Grid>
  </Grid>

const Row1 = ({ onVehicleOptionsChange, onDriverOptionsChange }) =>
  <Grid container spacing={1} rowSpacing={2} alignItems='flex-end'>
    <Grid size={6}>
      <ModelMenuSelectorField
        name='imposed_vehicle_options'
        label={I18n.t('vehicle.label.one')}
        model_name='vehicleoption'
        searchMode={'search'}
        config={{
          initial_filter: {},
          mutator: elem => ({ label: OptionUtils.getLabel(elem), ...elem })
        }}
        multiple
        afterChange={onVehicleOptionsChange}
      />
    </Grid>
    <Grid size={6}>
      <ModelMenuSelectorField
        name='imposed_driver_options'
        label={I18n.t('driver.label.one')}
        model_name='useroption'
        searchMode={'search'}
        config={{
          initial_filter: {},
          mutator: elem => ({ label: OptionUtils.getLabel(elem), ...elem })
        }}
        multiple
        afterChange={onDriverOptionsChange}
      />
    </Grid>
  </Grid>

const Row2 = ({ onVehicleOptionsChange, onDriverOptionsChange, fixedDefautlVehicleOptions, fixedDefautlDriverOptions }) =>
  <Grid container spacing={1} rowSpacing={2} alignItems='flex-end'>
    <Grid size={6}>
      <ModelMenuSelectorField
        name='default_vehicle_options'
        label={I18n.t('vehicle.label.one')}
        model_name='vehicleoption'
        searchMode={'search'}
        config={{
          initial_filter: {},
          mutator: elem => ({ label: OptionUtils.getLabel(elem), ...elem })
        }}
        multiple
        afterChange={onVehicleOptionsChange}
        disabledOptions={fixedDefautlVehicleOptions}
      />
    </Grid>
    <Grid size={6}>
      <ModelMenuSelectorField
        name='default_driver_options'
        label={I18n.t('driver.label.one')}
        model_name='useroption'
        searchMode={'search'}
        config={{
          initial_filter: {},
          mutator: elem => ({ label: OptionUtils.getLabel(elem), ...elem })
        }}
        multiple
        afterChange={onDriverOptionsChange}
        disabledOptions={fixedDefautlDriverOptions}
      />
    </Grid>
  </Grid>

const Row3 = ({ fixedAllowedVehicleOptions, fixedAllowedDriverOptions }) =>
  <Grid container spacing={1} rowSpacing={2} alignItems='flex-end'>
    <Grid size={6}>
      <ModelMenuSelectorField
        name='allowed_vehicle_options'
        label={I18n.t('vehicle.label.one')}
        model_name='vehicleoption'
        searchMode={'search'}
        config={{
          initial_filter: {},
          mutator: elem => ({ label: OptionUtils.getLabel(elem), ...elem })
        }}
        multiple
        disabledOptions={fixedAllowedVehicleOptions}
      />
    </Grid>
    <Grid size={6}>
      <ModelMenuSelectorField
        name='allowed_driver_options'
        label={I18n.t('driver.label.one')}
        model_name='useroption'
        searchMode={'search'}
        config={{
          initial_filter: {},
          mutator: elem => ({ label: OptionUtils.getLabel(elem), ...elem })
        }}
        multiple
        disabledOptions={fixedAllowedDriverOptions}
      />
    </Grid>
  </Grid>

const Row4 = () =>
  <Grid container spacing={2} rowSpacing={2} alignItems='flex-end'>
    <Grid size={6}>
      <ModelMenuSelectorField
        name='vehicletypes'
        label={I18n.t('vehicle.type')}
        model_name='vehicletype'
        labelKeys={['name_translated']}
        config={{
          initial_filter: {}
        }}
        searchMode={'search'}
        allowNone={false}
        multiple
      />
    </Grid>
    <Grid size={3}>
      <TextField
        name='max_load'
        label={I18n.t('load.count')}
        type='number'
        InputProps={{
          style: { width: '40%' },
          endAdornment: <Box sx={{ fontSize: 12, color: 'text.label' }}> {I18n.t('maximum.label.short')} </Box>,
        }}
      />
    </Grid>
  </Grid>


const FeatureSection = (props) => <>
  <StepLabel>
    <Typography variant='h5'>{I18n.t('feature.label', { count: -1 })}</Typography>
  </StepLabel>
  <StepContent>
    <Box sx={{ p: 5, boxShadow: 6, borderRadius: 3 }}>
      <Grid container rowSpacing={3} >
        <Grid size={12}>
          <Title title={I18n.t('options.label.imposed')} {...props} />
          <Row1 {...props} />
        </Grid>
        <Grid size={12}>
          <Title title={I18n.t('options.label.default')} {...props} />
          <Row2 {...props} />
        </Grid>
        <Grid size={12}>
          <Title title={I18n.t('options.allowed')} {...props} />
          <Row3 {...props} />
        </Grid>
        <Grid size={12}>
          <Title title={I18n.t('date.booking')} {...props} />
          <Row4 {...props} />
        </Grid>
      </Grid>
    </Box>
  </StepContent>
</>

export default React.memo(FeatureSection)
